import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams} from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tooltip } from 'primereact/tooltip';
import api from './../../service/api';
import { isAdmin } from '../../service/auth';
import { formatDate, formatCurrency } from '../../service/format';
import styles from './styles.module.css';

import CreateSupplier from '../Supplier/create';
import CreateExpense from '../Expense/create';
import UpdateExpense from '../Expense/update';
import DeleteExpense from '../Expense/delete';
import SupplyList from '../../components/SupplyList';
import InputDecimal from '../../components/InputDecimal';

const TravelDetail = () => {
    
    let emptyTravel = {
        freight: null,
        description: '',
        commission: null,
        deprecation: null,
        distance: null,
        fuelPrice: null,
        truck: null,
        isempty: false,
        voucher: null,
        truck_voucher: null,
        commission_percentage: 10
    };

    let emptyExpense = {
        description: null,
        amount: null,
        due_date: null,
        purchase_date:(new Date())
    }

    let emptySupply = {
        kilometer: null,
        amount: null,
        litre: null,
        isfull: false,
        date:(new Date()),
        supplier: null,
        withouttravel: false,
        ispaid: false
    }

    var travelInOutEmpty = {
        date: (new Date()),
        status: null,
        kilometer: null,
        advance: null,
        voucher: null,
        deposit: null
    }
    const { code } = useParams();

    const [startedDialog, setStartedDialog] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [travel, setTravel] = useState(emptyTravel);
    const [expense, setExpense] = useState(emptyExpense);
    const [supply, setSupply] = useState(emptySupply);
    const [travelInOut, setTravelInOut] = useState(travelInOutEmpty);
    const [disabled, setDisabled] = useState(false);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [expenseDialog, setExpenseDialog] = useState(false);
    const [supplyDialog, setSupplyDialog] = useState(false);
    const [loading, setLoading] = useState(true);

    const [totalExpense, setTotalExpense] = useState(0);
    const [totalSupply, setTotalSupply] = useState(0);
    const [totalLost, setTotalLost] = useState(0);

    const [showCreateSupplier, setShowCreateSupplier] = useState(false);
    const [suppliers, setSuppliers] = useState([]);

    const [finishDialog, setFinishDialog] = useState(false);

    const [updateExpenseDialog, setUpdateExpenseDialog] = useState(false);
    const [updateExpenseCode, setUpdateExpenseCode] = useState(false);
    const [deleteExpenseDialog, setDeleteExpenseDialog] = useState(false);

    const toast = useRef(null);
    const dt = useRef(null);
    const isadmin = isAdmin();

    const updateTravel = () => {

        var _travel = {...travel};

        Object.keys(travelInOut).forEach(key => {
            if(travelInOut[key]) _travel[key] = travelInOut[key];
        });

        if(typeof _travel['started'] == "object") _travel['started'] = _travel['started'].getTime();
        if(typeof _travel['completed'] == "object") _travel['completed'] = _travel['completed'].getTime();

        setDisabled(true);
        
        api().post('/travel/update', {..._travel }).then(response => {
            setDisabled(false);
            if(response.status === 200 && response.data.result){
                setTravel(_travel);
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
            }
        }).catch(error => {
            toast.current.show({severity: 'error', summary: 'Erro', detail: 'Não foi possível realizar a operação!'});
        });
    }

    const listTravel = () => {
        api().get('/travel/' + code).then(response => {
            if(response.status === 200 && response.data.result){
                setTravel(response.data.data);
                if(response.data.data.status === 'done' && !isadmin) 
                    setDisabled(true);
                setLoading(false);
            }
        });
    }

    const onTravelChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || null;
        let _travel = { ...travel };
        _travel[`${name}`] = val;

        setTravel(_travel);
    }

    const onInputInOutChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _travel = { ...travelInOut };
        _travel[`${name}`] = val;

        setTravelInOut(_travel);
    }

    const onInputSupplyChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _supply = { ...supply };
        _supply[`${name}`] = val;

        setSupply(_supply);
    }

    const listSuppliers = (defaultValue = null) => {
        api().get('supplier/list').then(response => {
            if(response.status === 200 && response.data.result){
                setSuppliers(response.data.data);
                if(defaultValue) onInputSupplyChange({ value: defaultValue }, 'supplier');
            }
        });
    }

    const hideStartedDialog = () => {
        setTravelInOut(travelInOutEmpty);
        setCancelDialog(false);
        setSubmitted(false);
        setStartedDialog(false);
    }

    const hideExpenseDialog = () => {
        setExpense(emptyExpense);
        setExpenseDialog(false);
        setSubmitted(false);
    }

    const hideSupplyDialog = () => {
        setSupply(emptySupply);
        setSupplyDialog(false);
        setSubmitted(false);
    }

    const showExpenseDialog = () => {
        setDisabled(false);
        setExpenseDialog(true);
        setSubmitted(false);
    }

    const showSupplyDialog = () => {
        setDisabled(false);
        setSupplyDialog(true);
        setSubmitted(false);
    }

    const showStartedDialog = () => {
        setDisabled(false);
        setStartedDialog(true);
        setSubmitted(false);
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Despesas da viagem</h5>
        </div>
    );

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Combustível" icon="pi pi-plus" className="p-button-success mr-2" onClick={showSupplyDialog} />
                    <Button label="Despesa" icon="pi pi-plus" className="p-button-warning mr-2" onClick={showExpenseDialog} />
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    {travel.status === 'pending' ? (
                        <Button label="Iniciar" loading={disabled}  onClick={() => {
                            onInputInOutChange({ value: 'processing'}, 'status');
                            showStartedDialog();
                        }} icon="pi pi-flag" className="p-button-info mr-2" />
                    ) : (travel.status === 'processing' ? (
                        <Button label="Concluir" loading={disabled}  onClick={() => {
                            onInputInOutChange({ value: 'analyze'}, 'status');
                            showStartedDialog();
                        }} icon="pi pi-check" className="p-button-success mr-2" />
                    ) : (travel.status === 'analyze' && isadmin ? (
                        <Button loading={disabled} label="Finalizar Análise" onClick={() => {
                            setFinishDialog(true);
                            
                        }} icon="pi pi-check" className="p-button-success mr-2" />
                    ) : ''
                    ))}
                </div>
            </React.Fragment>
        );
    }

    const handleInOut = (status = null) => {
        if(['analyze', 'processing'].includes(travelInOut.status) && (!travelInOut.kilometer || !travelInOut.date)) return setSubmitted(true);

        setSubmitted(false);
        setDisabled(true);

        var _travelInOut = {...travelInOut, code: travel.code, date: travelInOut.date.getTime()};

        if(status) _travelInOut['status'] = status;

        api().post(`travel/status`, _travelInOut).then(response => {
            setDisabled(false);
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTravel();
                hideStartedDialog();
            }
        }).catch(response => {
            toast.current.show({
                severity: 'warn', summary: 'Alerta', detail: response.data.message || ('Não foi possível realizar a operação')
            });
            setStartedDialog(false);
        });
    }

    const handleExpense = () => {
        if(!expense.description || !expense.purchase_date || !expense.amount) return setSubmitted(true);

        setSubmitted(false);
        setDisabled(true);

        var _expense = {...expense, 
            purchase_date: expense.purchase_date.getTime(), 
            payment_date: expense.purchase_date.getTime(), 
            travel: travel.code, truck: travel.truck};

        api().post(`expense/create`, _expense).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listExpenses();
                hideExpenseDialog();
            }
        }).catch(response => {
            toast.current.show({
                severity: 'warn', summary: 'Alerta', detail: response.data.message || ('Não foi possível realizar a operação')
            });
            hideExpenseDialog();
        });
    }

    const handleSupply = () => {
        if(!supply.litre || !supply.date || !supply.kilometer) return setSubmitted(true);

        setSubmitted(false);
        setDisabled(true);

        var _supply = {...supply, 
            date: supply.date.getTime(), 
            travel: travel.code, 
            truck: travel.truck,
            driver: travel.driver,
            create_expense: true
        };

        if(!_supply.amount) _supply.amount = 0;

        api().post(`supply/create`, _supply).then(response => {
            setDisabled(false);
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listExpenses();
                hideSupplyDialog();
            }
        }).catch(response => {
            setDisabled(false);
            toast.current.show({
                severity: 'warn', summary: 'Alerta', detail: response.data.message || ('Não foi possível realizar a operação')
            });
            hideSupplyDialog();
        });
    }

    const listExpenses = () => {
        if(!travel.code) return;

        api().get(`/expense/list/travel/${travel.code}`).then(response => {
            
            if(response.status === 200 && response.data.result){
                setExpenses(response.data.data);
                var totalExpenseGeneral = response.data.data.reduce((previous, current) => previous + current.amount, 0);

                var totalSupplyGeneral = response.data.data.filter(data => data.category === 1).reduce((previous, current) => previous + current.amount, 0);

                setTotalExpense(totalExpenseGeneral - totalSupplyGeneral);
                setTotalSupply(totalSupplyGeneral);

                var reference = { ...travel};
                var amountTravel = (reference.quantity_ton * reference.amount_ton);

                setTotalLost(
                    (amountTravel + (reference.truck_voucher || 0)) - totalExpenseGeneral - reference.deposit  - reference.voucher
                );
                
            }
        });
    }

    const finishTravel = () => {
        setFinishDialog(false);
        onInputInOutChange({ value: 'done'}, 'status');
        setDisabled(true);
        handleInOut('done');
    }

    const calcNetTotal = () => {
        var amountFreight = (travel.amount_ton * travel.quantity_ton);
        var commissionValue = amountFreight * travel.commission_percentage / 100; 

        if(travel.voucher > commissionValue) commissionValue += travel.voucher - commissionValue;

        var netTotal = amountFreight + travel.truck_voucher - totalLost - totalSupply - totalExpense - commissionValue;

        return (formatCurrency( netTotal, true))
    }

    const productDialogFooter = (type = 'travelInOut') => (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={() => type === 'travelInOut' ? hideStartedDialog() : hideExpenseDialog() } />
            <Button label="Salvar" loading={disabled} icon="pi pi-check" className="p-button-text" onClick={() => type === 'travelInOut' ? handleInOut() : handleExpense() } />
        </>
    );

    const supplyDialogFooter = () => (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideSupplyDialog} />
            <Button label="Salvar" loading={disabled} icon="pi pi-check" className="p-button-text" onClick={handleSupply} />
        </>
    );

    const canceledDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={() => setCancelDialog(false)} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleInOut} />
        </>
    );

    const inputToTravelProcessing = () => (
        <>
            <div className="field"> 
                <label htmlFor="advance">Valor de Adiantamento do Frete (Opcional)</label>
                <InputDecimal id="advance" value={travelInOut.advance} mode='currency' onChange={(e) => onInputInOutChange(e, 'advance')} />
            </div>
            <div className="field"> 
                <label htmlFor="truckVoucher">Valor de Vale Caminhão (Opcional)</label>
                <InputDecimal id="truckVoucher" value={travelInOut.truck_voucher} mode='currency' onChange={(e) => onInputInOutChange(e, 'truck_voucher')} />
            </div>
        </>
    );

    const inputToTravelAnalyze = () => (
        <>
            <div className="field">
                <label htmlFor="voucher">Valor de Vale do Motorista (Opcional)</label>
                <InputDecimal id="voucher" value={travelInOut.voucher} mode='currency' maxFractionDigits={2}  onChange={(e) => onInputInOutChange(e, 'voucher')} />
            </div><div className="field">
                <label htmlFor="deposit">Valor de Depósito (Opcional)</label>
                <InputDecimal id="deposit" value={travelInOut.deposit} mode='currency' maxFractionDigits={2}  onChange={(e) => onInputInOutChange(e, 'deposit')} />
                <small><i>Sugestão de valor: </i> {formatCurrency(totalLost, true)}</small>
            </div>
        </>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={() => {
                    setUpdateExpenseCode(rowData.code || false);
                    setDeleteExpenseDialog(true);
                }} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info mr-2" onClick={() => {
                    setUpdateExpenseCode(rowData.code || false);
                    setUpdateExpenseDialog(true); 
                }} />
            </div>
        );
    }

    useEffect(() => {
        listTravel();
        listSuppliers();
        
    }, []);

    useEffect(() => {
        listExpenses();
    }, [travel]);

    return (
        <div className="grid crud-demo">
          
            <div className="col-12">
                <div className="card">
                    <Link to={'/travel'}><span className={styles.goBack}><i className="pi pi-arrow-left"></i> Voltar para viagens</span></Link>
                    <Toast ref={toast} />
                    {!loading && (travel.status !== 'done' || isadmin) ? (
                        <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                    ): ''}
                    <TabView>
                        <TabPanel header="Geral">
                            <div className="p-fluid" style={{ marginTop: 20 }}>
                                <div className="formgrid grid">
                                    <div className="field col-12">
                                        <label htmlFor="description">Descrição</label>
                                        <InputText disabled={disabled} id="description" value={travel.description} onChange={(e) => onTravelChange(e, 'description')} />
                                    </div>
                                </div>

                                <div className="formgrid grid">
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="description">Valor do frete</label>
                                        <InputText disabled id="description" value={formatCurrency(travel.amount_ton * travel.quantity_ton, true)} />
                                    </div>
                                
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="depositVal">Valor de Adiantamento do frete</label>
                                        <InputDecimal mode="currency" disabled={disabled} id="advanceVal" value={(travel.advance || null)} onChange={(e) => onTravelChange(e, 'advance')} />
                                    </div>

                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="depositVal">Valor Depositado</label>
                                        <InputDecimal mode="currency" disabled={disabled} id="depositVal" value={(travel.deposit || null)} onChange={(e) => onTravelChange(e, 'deposit')} />
                                    </div>
                                    
                                </div>
                                <div className="formgrid grid">
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="truckVoucherVal">Valor de Vale Caminhão</label>
                                        <InputDecimal mode="currency" disabled={disabled} id="truckVoucherVal" value={(travel.truck_voucher || null)} onChange={(e) => onTravelChange(e, 'truck_voucher')} />
                                    </div>

                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="voucherVal">Valor de Vale do Motorista</label>
                                        <InputDecimal mode="currency" disabled={disabled} id="voucherVal" value={(travel.voucher || null)} onChange={(e) => onTravelChange(e, 'voucher')} />
                                    </div>

                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="commission_percentage">Porcentagem da Comissão (%)</label>
                                        <InputNumber maxFractionDigits={2}  disabled={disabled} id="commission_percentage" value={(travel.commission_percentage || 0)} onChange={(e) => onTravelChange(e, 'commission_percentage')} />
                                    </div>
                                </div>

                                <div className="formgrid grid">
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="product">Produto </label>
                                        <InputText disabled={disabled} id="product" value={travel.product} onChange={(e) => onTravelChange(e, 'product')} />
                                    </div>
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="quantity_ton">Quantidade (Ton)</label>
                                        <InputDecimal maxFractionDigits={3}  disabled={disabled} id="quantity_ton" value={(travel.quantity_ton || 0)} onChange={(e) => onTravelChange(e, 'quantity_ton')} />
                                    </div>
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="amount_tonVal">Valor por Tonelada</label>
                                        <InputDecimal disabled={disabled} id="amount_tonVal" value={(travel.amount_ton || 0)} mode="currency" onChange={(e) => onTravelChange(e, 'amount_ton')} />
                                    </div>
                                </div>

                                <div className="formgrid grid">
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="driver">Motorista</label>
                                        <InputText disabled id="driver" value={travel.driverName} />
                                    </div>
                                    
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="truck">Caminhão (Placa)</label>
                                        <InputText disabled id="truck" value={String(travel.plate || '').toUpperCase()} />
                                    </div>
                                </div>

                                <div className="formgrid grid">
                                    <div className="field lg:col-6 col-12">
                                        <label htmlFor="kilometer_initialVal">Hodômetro Inicial </label>
                                        <InputNumber maxFractionDigits={0} disabled={disabled} id="kilometer_initialVal" value={(travel.kilometer_initial || null)} onChange={(e) => onTravelChange(e, 'kilometer_initial')} />
                                    </div>
                                    <div className="field lg:col-6 col-12">
                                        <label htmlFor="kilometer_finalVal">Hodômetro Final</label>
                                        <InputNumber disabled={disabled} maxFractionDigits={0} id="kilometer_finalVal" value={(travel.kilometer_final || null)} onChange={(e) => onTravelChange(e, 'kilometer_final')} />
                                    </div>
                                </div>

                                <div className="formgrid grid">
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="started">Data de Início</label>
                                        <Calendar id="started" disabled={disabled} dateFormat='dd/mm/yy' locale='pt-br' value={travel.started ? new Date(travel.started) : null} onChange={(e) => onInputInOutChange(e, 'started')} showIcon />
                                    </div>
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="completed">Data de finalização</label>
                                        <Calendar id="completed" disabled={disabled} dateFormat='dd/mm/yy' locale='pt-br' value={travel.completed ? new Date(travel.completed) : null} onChange={(e) => onInputInOutChange(e, 'completed')} showIcon />
                                    </div>
                                    <div className="field lg:col-4 col-12">
                                        <label htmlFor="createdat">Data de Criação</label>
                                        <InputText  id="createdat" value={travel.createdat ? formatDate(travel.createdat, false) : '-'} disabled />
                                    </div>
                                </div>
                                {travel.status !== 'done' || isadmin ? (
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button loading={disabled} label="Salvar Alterações" style={{ width: 'fit-content' }} icon="pi pi-save" onClick={updateTravel} />
                                    </div>
                                ) : ''}
                                
                            </div>
                        </TabPanel>
                        <TabPanel header="Despesas">
                            <DataTable ref={dt} 
                                dataKey="id"  className="datatable-responsive"
                                paginatorTemplate="" value={expenses}
                                emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                                <Column field="description"  header="Descrição" headerStyle={{ width: '50%', minWidth: '10rem' }}></Column>
                                <Column field="suppliername" header="Fornecedor" style={{whiteSpace: 'nowrap'}}></Column>
                                <Column field="categorydescription" style={{whiteSpace: 'nowrap'}} header="Categoria"></Column>
                                <Column field="amount" body={rowData => (rowData.amount || 0) ? (formatCurrency(rowData.amount, true)) : '-'} header="Valor"></Column>
                                <Column field="purchase_date" body={rowData => (rowData.purchase_date || 0) ? (formatDate(rowData.purchase_date, false)) : '-'} header="Data da Compra"></Column>
                                {travel.status !== 'done' ? <Column body={actionBodyTemplate} style={{width: '20%', whiteSpace: 'nowrap'}}></Column> : <></>}
                            </DataTable>  
                        </TabPanel>
                        <TabPanel header="Abastecimentos">
                            <SupplyList supply={supplyDialog} onDelete={data => {
                                if(data.success) {
                                    listExpenses();
                                    toast.current.show({severity: 'success', summary: 'Sucesso', detail: data.message});
                                } else toast.current.show({
                                    severity: 'error', summary: 'Erro', 
                                    detail: 'Não foi possível excluir o abastecimento!' 
                                });
                            }} travel={{code, ...travel}} />
                        </TabPanel>
                        <TabPanel header="Resumo">
                            <div className={styles.resumeContainer}>
                                <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                    <h4 className="m-0">Resumo</h4>
                                </div>
                                <div className={styles.resumeItems}>
                                    <div className={styles.driverCommission}>
                                        <div>
                                            <div>Comissão: </div>
                                            <div>{formatCurrency((travel.commission_percentage * travel.quantity_ton * travel.amount_ton / 100), true)}</div>
                                        </div>
                                        <div>
                                            <div>Vale: </div>
                                            <div>{formatCurrency(travel.voucher, true)}</div>
                                        </div>
                                        <div>
                                            <div>A Receber: </div>
                                            <div>{formatCurrency((travel.commission_percentage * travel.quantity_ton * travel.amount_ton / 100) - travel.voucher, true)}</div>
                                        </div>
                                    </div>
                                    <div className={styles.resumeTravel}>
                                        <div>
                                            <div><strong>Total Bruto:</strong></div>
                                            <div className={styles.success}>{formatCurrency(travel.amount_ton * travel.quantity_ton + (travel.truck_voucher || 0), true)}</div>
                                        </div>
                                        <hr style={{ marginTop: 0, marginBottom: 0 }} />
                                        <div>
                                            <div><strong>Total Frete:</strong></div>
                                            <div>{formatCurrency(travel.amount_ton * travel.quantity_ton, true)}</div>
                                        </div>
                                        <div>
                                            <div>Vale Caminhão: </div>
                                            <div>{formatCurrency(travel.truck_voucher || 0, true)}</div>
                                        </div>
                                        
                                        {isadmin ? (
                                            <>
                                                <hr style={{ marginTop: 0, marginBottom: 0 }} />
                                                <div>
                                                    <div>Total Depositado: </div>
                                                    <div className={styles.success}>{formatCurrency(travel.deposit, true)}</div>
                                                </div>
                                                <hr style={{ marginTop: 0, marginBottom: 0 }} />
                                                <div>
                                                    <div>Total Despesas: </div>
                                                    <div>{formatCurrency(totalExpense, true)}</div>
                                                </div>
                                                <div>
                                                    <div>Total Combustível: </div>
                                                    <div>{formatCurrency(totalSupply, true)}</div>
                                                </div>
                                                <div>
                                                    <div>Total não Declarado: </div>
                                                    <div className={styles.alert} style={{ color: totalLost >= 0 ? '#c33440' : '#3ed266' }}>{formatCurrency(totalLost > 0 ? totalLost : -1 * totalLost, true)}</div>
                                                </div>
                                                <hr style={{ marginTop: 0, marginBottom: 0 }} />
                                                <div>
                                                    <div><strong>Total Líquido:</strong></div>
                                                    <div>{calcNetTotal()}</div>
                                                </div>
                                            </>
                                        ) : ''}
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                    
                    <Dialog visible={startedDialog} style={{ width: '450px' }} header={travelInOut.status === 'processing' ? 'Iniciar viagem' : 'Concluir viagem'} modal className="p-fluid" footer={() => productDialogFooter('travelInOut')} onHide={hideStartedDialog}>
                        <div className="field">
                            <label htmlFor="kilometer">Quilometragem do hodômetro</label>
                            <InputNumber id="kilometer" autoFocus value={travelInOut.kilometer} maxFractionDigits={0} onChange={(e) => onInputInOutChange(e, 'kilometer')} required />
                        </div>

                        <div className="field">
                            <label htmlFor="date">Data</label>
                            <Calendar id="date" dateFormat='dd/mm/yy' locale='pt-br' value={travelInOut.date} onChange={(e) => onInputInOutChange(e, 'date')} showIcon />
                        </div>

                        {travelInOut.status === 'processing' ? inputToTravelProcessing() : inputToTravelAnalyze() }
                    </Dialog>

                    <Dialog visible={cancelDialog} style={{ width: '450px' }} header="Atenção" modal footer={canceledDialogFooter}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {travel && <span>Você tem certeza que deseja cancelar esta viagem?</span>}
                        </div>
                    </Dialog>

                    <CreateExpense visible={expenseDialog} ispaid handleCancel={() => setExpenseDialog(false)} truck={travel.truck} travel={travel.code} onCreate={_expense => {
                        setExpenseDialog(false);
                        listExpenses();
                        setDisabled(false);
                    }} />

                    <UpdateExpense code={updateExpenseCode} visible={updateExpenseDialog} onUpdate={() => {
                        listExpenses();
                        setUpdateExpenseDialog(false);
                    }} handleCancel={() => {
                        setUpdateExpenseDialog(false);
                    }} />

                    <DeleteExpense code={updateExpenseCode} visible={deleteExpenseDialog} onDelete={() => {
                        listExpenses();
                        setDeleteExpenseDialog(false);
                    }} handleCancel={() => {
                        setDeleteExpenseDialog(false);
                    }} />

                    <CreateSupplier visible={showCreateSupplier} handleCancel={() => {
                        setShowCreateSupplier(false);
                        }} onCreate={response => {
                            setShowCreateSupplier(false);
                            if(response.data)
                                listSuppliers(response.data);
                    }} />


                    <Dialog visible={supplyDialog} style={{ width: '450px' }} header="Abastecimento" modal className="p-fluid" footer={supplyDialogFooter} onHide={hideSupplyDialog}>
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor='supplier'>Fornecedor (Opcional)</label>
                                <div style={{ display: 'flex' }}>
                                    <Dropdown disabled={disabled} value={supply.supplier} autoFocus style={{ width: '100%' }} showClear emptyMessage='Nenhum registro encontrado'  id="supplier" options={suppliers} onChange={(e) => onInputSupplyChange(e, 'supplier')} optionLabel="name" optionValue='code' placeholder="Selecione o fornecedor" />
                                    <Button disabled={disabled} onClick={() => {
                                        setShowCreateSupplier(true);
                                    }} className='p-button-text' icon='pi pi-plus' />
                                </div>
                                
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor="kilometerSupply">Hodômetro</label>
                            <InputNumber disabled={disabled} id="kilometerSupply"  mode='decimal' value={supply.kilometer} maxFractionDigits={0} onChange={(e) => onInputSupplyChange(e, 'kilometer')} required />
                            {submitted && !expense.kilometer && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                        </div>

                        <div className="field">
                            <label htmlFor="dateSupply">Data</label>
                            <Calendar id="dateSupply" dateFormat='dd/mm/yy' locale='pt-br' value={supply.date} onChange={(e) => onInputSupplyChange(e, 'date')} showIcon />
                            {submitted && !supply.date && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                        </div>
                       
                        <div className="field">
                            <label htmlFor="amountExpense">Valor</label>
                            <InputDecimal disabled={disabled} id="amountExpense" value={supply.amount} mode='currency'  onChange={(e) => onInputSupplyChange(e, 'amount')} />
                        </div>

                        <div className="field">
                            <label htmlFor="amountExpense">Litros</label>
                            <InputDecimal disabled={disabled} id="amountExpense" value={supply.litre} mode='decimal' maxFractionDigits={3}  onChange={(e) => onInputSupplyChange(e, 'litre')} />
                            {submitted && !supply.litre && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                        </div>

                        <div className="field-checkbox">
                            <hr />
                            <Checkbox disabled={disabled} tooltip="" inputId="withOutTravel" checked={supply.withouttravel} onChange={e => {
                                var  _supply = { ...supply};
                                _supply['withouttravel'] = e.checked;
                                setSupply(_supply);
                            }} />
                            <label htmlFor="withOutTravel">
                                Despesa Desvinculada da Viagem  
                                <i style={{ color: '#c33440', marginLeft: 5 }} 
                                data-pr-tooltip="Marcando esta opção, a despesa gerada com o abastecimento
                                 não será somada ao montante de despesas dessa viagem!"
                                data-pr-position="top"
                                 className="pi pi-info-circle text-danger"></i>
                            </label>
                            <Tooltip target={'.pi-info-circle'} />
                        </div>
                        <div className="field-checkbox">
                            <hr />
                            <Checkbox disabled={disabled} inputId="binary" checked={supply.ispaid} onChange={e => {
                                var  _supply = { ...supply};
                                _supply['ispaid'] = e.checked;
                                setSupply(_supply);
                            }} />
                            <label htmlFor="binary">Despesa Paga</label>
                        </div>
                       
                    </Dialog>

                    <Dialog visible={finishDialog} style={{ width: '450px' }} onHide={() => setFinishDialog(false)} header="Atenção" modal footer={() => 
                        (<>
                            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={() => {
                                setFinishDialog(false);
                            }} />
                            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={finishTravel} />
                        </>)
                    }>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {<span>Você deseja finalizar a análise da viagem?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}

export default TravelDetail;